import { TFunction } from "i18next";
import { TicketToUpdate } from "./context/formContext";
import { MeetingInstance } from "@services/meetings/types";

export const getSubTypeList = (t: TFunction) => {
  return [
    { value: "Link Down", title: t("Communication Link") },
    { value: "Ping Latency", title: t("Ping Latency") },
    { value: "Login Error", title: t("Login to Device") },
    { value: "API Error", title: t("Adapter Link") },
    { value: "H323 Registration", title: t("Gatekeeper Registration") },
    { value: "SIP Registration", title: t("SIP Registration") },
    {
      value: "Packet Loss Rx",
      title: t("Codec Media Packet Loss Receive (%)"),
    },
    { value: "Packet Loss Tx", title: t("Codec Media Packet Loss Send (%)") },
    {
      value: "Content Packet Loss Rx",
      title: t("Codec Content Packet Loss Receive (%)"),
    },
    {
      value: "Content Packet Loss Tx",
      title: t("Codec Content Packet Loss Send (%)"),
    },
    { value: "Audio Jitter Rx", title: t("Codec Audio Jitter Receive (ms)") },
    { value: "Audio Jitter Tx", title: t("Codec Audio Jitter Send (ms)") },
    { value: "Video Jitter Rx", title: t("Codec Video Jitter Receive (ms)") },
    { value: "Video Jitter Tx", title: t("Codec Video Jitter Send (ms)") },
    {
      value: "Content Jitter Rx",
      title: t("Codec Content Jitter Receive (ms)"),
    },
    {
      value: "Content Jitter Tx",
      title: t("Codec Content Jitter Send (ms)"),
    },
    { value: "Frame Rate Rx", title: t("Codec Video Speed Receive (fps)") },
    { value: "Frame Rate Tx", title: t("Codec Video Speed Send (fps)") },
    {
      value: "Content Frame Rate Rx",
      title: t("Codec Content Speed Receive (fps)"),
    },
    {
      value: "Content Frame Rate Tx",
      title: t("Codec Content Speed Send (fps)"),
    },
    {
      value: "Resolution Height Rx",
      title: t("Codec Video Resolution Receive"),
    },
    {
      value: "Resolution Height Tx",
      title: t("Codec Video Resolution Send"),
    },
    {
      value: "Content Resolution Height Rx",
      title: t("Codec Content Resolution Receive"),
    },
    {
      value: "Content Resolution Height Tx",
      title: t("Codec Content Resolution Send"),
    },
    { value: "portUtilization", title: t("MCU Ports Usage (%)") },
    { value: "Component Reachability", title: t("Communication Link") },
    { value: "CPU Usage", title: t("PC CPU Usage (%)") },
    { value: "Memory Usage", title: t("PC Memory Usage (%)") },
    { value: "Bandwidth Usage (In)", title: t("PC Bandwidth IN (Mbps)") },
    { value: "Bandwidth Usage (Out)", title: t("PC Bandwidth OUT (Mbps)") },
  ];
};

export const getSubject = (
  ticket: TicketToUpdate,
  commonIssue: string,
  meeting?: Partial<MeetingInstance>,
  deviceId?: string,
  meetingId?: string
) => {
  if (meetingId) {
    return meeting === undefined
      ? commonIssue
      : `${commonIssue} / Meeting ${meetingId} / ${meeting.account?.name}`;
  }

  if (deviceId || ticket.room) {
    const room = ticket.device?.room ?? ticket.room;
    if (room?.location?.account)
      return `${commonIssue} / ${room.name} / ${room.location.name} / ${room.location.account.name}`;
    return commonIssue;
  }

  return "";
};
